import { FilterTypes } from "@/data/table";
import i18n from "@/i18n";

export enum CustomFieldsMajorTypes {
  BASKET = "basket",
  CANCEL_REQUEST = "contract_request",
  CLIENT = "client",
  INVOICE = "invoice"
}

export enum CustomFieldsTypes {
  TEXT = 1,
  PASSWORD = 2,
  SELECT = 3,
  SELECT_RADIO = 4,
  TEXTAREA = 5,
  DATE = 6,
  NUMBER = 7,
  IMAGE = 8
}

export const CustomFieldsFilterTypes: {
  [key in CustomFieldsTypes]: string;
} = {
  [CustomFieldsTypes.TEXT]: FilterTypes.STRING,
  [CustomFieldsTypes.PASSWORD]: FilterTypes.STRING,
  [CustomFieldsTypes.SELECT]: FilterTypes.SELECT,
  [CustomFieldsTypes.SELECT_RADIO]: FilterTypes.SELECT_RADIO,
  [CustomFieldsTypes.TEXTAREA]: FilterTypes.STRING,
  [CustomFieldsTypes.DATE]: FilterTypes.DATE,
  [CustomFieldsTypes.NUMBER]: FilterTypes.NUMBER,
  [CustomFieldsTypes.IMAGE]: ""
};

export const CustomFieldTypesMap = () => {
  return {
    [CustomFieldsTypes.TEXT]: {
      label: i18n.t("_.text_input"),
      icon: "font"
    },
    [CustomFieldsTypes.PASSWORD]: {
      label: i18n.t("_.password"),
      icon: "lock"
    },
    [CustomFieldsTypes.SELECT]: {
      label: i18n.t("_.select"),
      icon: "chevron-circle-down"
    },
    [CustomFieldsTypes.SELECT_RADIO]: {
      label: i18n.t("_.checkbox"),
      icon: "check-circle"
    },
    [CustomFieldsTypes.TEXTAREA]: {
      label: i18n.t("_.textarea"),
      icon: "align-left"
    },
    [CustomFieldsTypes.DATE]: {
      label: i18n.t("_.date"),
      icon: "calendar-alt"
    },
    [CustomFieldsTypes.NUMBER]: {
      label: i18n.t("_.number"),
      icon: "hashtag"
    },
    [CustomFieldsTypes.IMAGE]: {
      label: i18n.t("_.image"),
      icon: "image"
    }
  };
};
